// @flow
import { withNavigation } from '@react-navigation/compat';
import React, { Component } from 'react';

import I18n from '../../../lib/i18n';
import ListItemRadio from '../../common/ListItemRadio';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import type { Subscription } from 'digicel-kaizen-library';

export class LineRow extends Component<Props> {
  _select = () => {
    this.props.navigation.goBack();
    this.props.selectSubscription(this.props.subscription);
  };
  _updateAlias(params) {
    this.props.updatePhoneLineAlias(params.id, params.subtitle);
  }
  render() {
    const { subscription } = this.props;
    const phoneLine = subscription.line;

    return (
      <ListItemRadio
        first={false}
        id={phoneLine.number}
        isEditing={this.props.isEditing}
        onSelect={this._select}
        selected={this.props.selected}
        subtitle={phoneLine.alias}
        subtitleChanged={params => this._updateAlias(params)}
        subtitlePlaceholder={I18n.t('addAlias')}
        title={phoneLine.number}
      />
    );
  }
}

type Props = {
  isEditing: boolean,
  navigation: NavigationScreenProp<NavigationRoute>,
  selected: boolean,
  selectSubscription: Subscription => void,
  subscription: Subscription,
  updatePhoneLineAlias: Function,
};

export default withNavigation(LineRow);
